import get from 'lodash/get'
import isNil from 'lodash/isNil'
import OLFeature from 'ol/Feature'
import OLGeomLineString from 'ol/geom/LineString'
import OLStyleStroke from 'ol/style/Stroke'
import OLStyleStyle from 'ol/style/Style'

/**
 * Add the route to the map
 *
 * @param {object} featureCollection
 * @param {turfPoint} start
 * @param {turfPoint} finish
 */
export default function (featureCollection, start, finish, style) {
  if (isNil(featureCollection)) {
    return null
  }
  const features = get(featureCollection, 'features', [])
  const coordArr = features.map(function (feature) {
    const coords = get(feature, 'geometry.coordinates', null)
    return window.appObject.transformFrom4326(coords)
  })

  addMainRoute(coordArr, style)
  addLinkLines(coordArr, start, finish)
}

function addMainRoute (coordArr, style) {
  const routeGeom = new OLGeomLineString(coordArr)
  // Build a feature with this geometry
  const routeFeature = new OLFeature({
    geometry: routeGeom,
    name: 'My Route'
  })
  if (!isNil(style)) {
    routeFeature.setStyle(style)
  }
  window.appObject.routingOverlay.getSource().addFeature(routeFeature)
}

function addLinkLines (coordArr, start, finish) {
  if (!isNil(start) && !isNil(finish)) {
    const coordsStart = get(start, 'geometry.coordinates', null)
    const start3857 = window.appObject.transformFrom4326(coordsStart)
    const coordsFinish = get(finish, 'geometry.coordinates', null)
    const finish3857 = window.appObject.transformFrom4326(coordsFinish)
    const firstPointInRoute = coordArr[0]
    const lastFirstPointInRoute = coordArr[coordArr.length - 1]
    const geomToStart = new OLGeomLineString([start3857, firstPointInRoute])
    const geomToFinish = new OLGeomLineString([finish3857, lastFirstPointInRoute])
    const style = new OLStyleStyle({
      stroke: new OLStyleStroke({
        color: 'rgba(0, 0, 0, 0.30)',
        width: 8
      })
    })
    const routeFeatureStart = new OLFeature({
      geometry: geomToStart,
      name: 'My Route Start'
    })
    routeFeatureStart.setStyle(style)

    const routeFeatureFinish = new OLFeature({
      geometry: geomToFinish,
      name: 'My Route Finish'
    })
    routeFeatureFinish.setStyle(style)

    window.appObject.routingOverlay.getSource().addFeature(routeFeatureStart)
    window.appObject.routingOverlay.getSource().addFeature(routeFeatureFinish)
  }
}
